import React, { useEffect, useState } from 'react';
import '../../assets/css/manage.css';
import axiosInstance from '../../api/axiosInstance';

const NtfcPopup = ({ onClose, anchorRef, title = "알림명", message = "알림사항이 없습니다." }) => {

  const [item, setItem] = useState({});   // 마스터 아이템 
  const [style, setStyle] = useState({}); // 알림창 반응형으로 위치 조정하기 위함

  useEffect(() => {
    S_01();
  }, []);

  useEffect(() => {
    const updatePosition = () => {
      if (anchorRef?.current) {
        const rect = anchorRef.current.getBoundingClientRect();
        const popupWidth = 300;
        const popupHeight = 500;
        const spacing = 8;

        let top = rect.bottom + spacing + window.scrollY;
        let left = rect.left + window.scrollX;

        if (left + popupWidth > window.innerWidth - 8) {
          left = window.innerWidth - popupWidth - 8;
        }

        if (top + popupHeight > window.innerHeight + window.scrollY - 8) {
          top = rect.top + window.scrollY - popupHeight - spacing;
        }

        setStyle({
          position: 'absolute',
          top: `${top}px`,
          left: `${left}px`,
          width: `${popupWidth}px`,
          maxWidth: '90vw',
          background: '#fff',
          boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
          borderRadius: '6px',
          padding: '16px',
          zIndex: 9999,
        });
      }
    };

    // 초기 계산
    updatePosition();

    // 윈도우 리사이즈, 스크롤 대응
    window.addEventListener('resize', updatePosition);
    window.addEventListener('scroll', updatePosition);

    return () => {
      window.removeEventListener('resize', updatePosition);
      window.removeEventListener('scroll', updatePosition);
    };
  }, [anchorRef]);


  // 최근 알림 조회
  const S_01 = async () => {
    try {
        const NtfctRes = await axiosInstance.get('/ntfctMng/findNtfctMng');
        
        // 아이템 상태값 추가 
        NtfctRes.data.forEach(element => {
            element.status = 'load';
        });
        
        const thisItem = [...NtfctRes.data]
        .filter(item => item.MDFCN_DT)
        .sort((a, b) => new Date(b.MDFCN_DT) - new Date(a.MDFCN_DT))[0];
      
        thisItem.MDFCN_DT = thisItem.MDFCN_DT?.split(' ')[0];
        setItem(thisItem);
        
        
    } catch (error) {
        console.error('Error ComponentMaster - S_01', error)
    }
};

  return (
    <div style={style} className="ntfc-popup">
      <h2 style={{ display: 'flex', justifyContent: 'space-between' }}>
        <span>{title}</span>
        <span style={{ fontSize: '0.8rem', color: '#666' }}>
          {item.MDFCN_DT?.split(' ')[0]}
        </span>
      </h2>
      <p>{item.NTFCT_CN || message}</p>
      <button className="close-btn" onClick={onClose}>
        닫기
      </button>
    </div>
  );
};

export default NtfcPopup;
